import { render, staticRenderFns } from "./FamousCommentBottomBar.vue?vue&type=template&id=219d71be&"
import script from "./FamousCommentBottomBar.vue?vue&type=script&lang=js&"
export * from "./FamousCommentBottomBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports